(function () {
  'use strict';

  function initializeSizeGuide(root) {
    if (!root || root.dataset.productSizeGuideInitialized === 'true') return;

    var trigger = root.querySelector('[data-product-size-guide-open]');
    var drawer = root.querySelector('[data-product-size-guide-drawer]');
    if (!trigger || !drawer) return;

    root.dataset.productSizeGuideInitialized = 'true';

    var closeButtons = drawer.querySelectorAll('[data-product-size-guide-close]');
    var tabs = drawer.querySelectorAll('[data-product-size-guide-tab]');
    var panels = drawer.querySelectorAll('[data-product-size-guide-panel]');
    var originalParent = drawer.parentNode;
    var originalNextSibling = drawer.nextSibling;

    function openDrawer() {
      if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ProductTabsSizeGuideDrawerOpen');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ProductTabsSizeGuideDrawerOpen');

      if (originalParent && drawer.parentNode === document.body) {
        originalParent.insertBefore(drawer, originalNextSibling);
      }

      trigger.focus();
    }

    function selectTab(index) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.productSizeGuideTab === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var active = panel.dataset.productSizeGuidePanel === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }

    trigger.addEventListener('click', openDrawer);
    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        selectTab(tab.dataset.productSizeGuideTab);
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-product-tabs-size-guide]').forEach(initializeSizeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
